import { ActualPageProps } from '../entities/Page';
import { CustomLink, Sidebar, SidebarCategory } from '../entities/Sidebar';
import {
  ALL_DOCS,
  CLI_PAGE,
  CLOUD_PAGE,
  CLOUD_PATH,
  EXAMPLES_PAGE,
  EXAMPLES_PATH,
  HARDWARE_PAGE,
  HARDWARE_PATH,
  LANGUAGE_REFERENCE_EN_PAGE,
  LANGUAGE_REFERENCE_PAGE,
  LANGUAGE_REFERENCE_PATH,
  LEARN_PAGE,
  LEARN_PATH,
  LIBRARY_GEN_PATH,
  LIBRARY_PAGE,
  MICROPYTHON_PAGE,
  MYCROPYTHON_PATH,
  PRODUCT_PATH,
  RETIRED_PAGE,
  RETIRED_PATH,
  SIDEBAR_CLOUD,
  SIDEBAR_EXAMPLES,
  SIDEBAR_HARDWARE,
  SIDEBAR_IDE_SOFTWARE,
  SIDEBAR_LANGUAGE,
  SIDEBAR_LEARN,
  SIDEBAR_LEGACY_DOCS,
  SIDEBAR_LIBRARY,
  SIDEBAR_MYCROPYTHON,
  SIDEBAR_PLC_SOFTWARE,
  SIDEBAR_SOFTWARE,
  SIDEBAR_TUTORIALS,
  SOFTWARE_IDE_PAGE,
  SOFTWARE_IDE_PATH,
  SOFTWARE_PAGE,
  SOFTWARE_PATH,
  SOFTWARE_PLC_PAGE,
  SOFTWARE_PLC_PATH,
  TEMP_HACKING,
  TEMP_LIBRARY_EXAMPLE,
  TUTORIALS_PAGE,
  TUTORIAL_COMMUNICATION,
  TUTORIAL_GENERIC,
  TUTORIAL_NANO_GENERIC,
  TUTORIAL_PROJECT,
  TUTORIAL_SECURITY,
} from './constants';

export function getSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.pages.edges.forEach((page) => {
    const nestedCat = [];

    data.pages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter?.icon || null,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function getRetiredSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.retiredPages.edges.forEach((page) => {
    const nestedChild = [];
    const nestedCat = [];

    data.retiredPages.edges.forEach((childPage) => {
      const parts = childPage.node.relativeDirectory.split('/');
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        if (parts[1] === TEMP_LIBRARY_EXAMPLE) {
          if (parts.length === 3) {
            let childs = [];
            data.retiredPages.edges.forEach((libraryChildPage) => {
              const nestedParts = libraryChildPage.node.relativeDirectory.split('/');
              if (nestedParts[1] === TEMP_LIBRARY_EXAMPLE) {
                if (nestedParts.length === 4 && parts[2] === nestedParts[2]) {
                  childs.push({ title: libraryChildPage.node.childMdx.frontmatter.title, url: libraryChildPage.node.fields.slug });
                }
              }
            });
            nestedCat.push({ category: childPage.node.childMdx.frontmatter.title, nestedChildren: childs });
          }
        } else if (parts[1] === TEMP_HACKING) {
          if (parts.length === 3) {
            let childs = [];
            data.retiredPages.edges.forEach((libraryChildPage) => {
              const nestedParts = libraryChildPage.node.relativeDirectory.split('/');
              if (nestedParts[1] === TEMP_HACKING) {
                if (nestedParts.length === 4 && parts[2] === nestedParts[2]) {
                  childs.push({ title: libraryChildPage.node.childMdx.frontmatter.title, url: libraryChildPage.node.fields.slug });
                }
              }
            });
            nestedCat.push({ category: childPage.node.childMdx.frontmatter.title, nestedChildren: childs });
          }
        } else nestedChild.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      if (page.node.relativeDirectory.split('/')[1] === TEMP_LIBRARY_EXAMPLE || page.node.relativeDirectory.split('/')[1] === TEMP_HACKING) {
        refactoredData.push({
          firstLevelCategory: page.node.childMdx.frontmatter.title,
          image: page.node.childMdx.frontmatter?.icon || null,
          nestedCategories: nestedCat,
        });
      } else {
        refactoredData.push({
          firstLevelCategory: page.node.childMdx.frontmatter.title,
          image: page.node.childMdx.frontmatter?.icon || null,
          nestedCategories: [{ category: null, nestedChildren: nestedChild }],
        });
      }
    }
  });

  return refactoredData;
}

export function getSoftwareSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  data.softwarePages.edges.forEach((page) => {
    const nestedCat = [];
    data.softwareSubpages.edges.forEach((subpage) => {
      if (
        page.node.relativeDirectory.length === subpage.node.relativeDirectory.length ||
        subpage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({
          title: subpage.node.childMdx.frontmatter.title,
          url: subpage.node.fields.slug,
          description: subpage.node.childMdx.frontmatter.description,
          difficulty: subpage.node.childMdx.frontmatter.difficulty,
        });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter.icon,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });
  return refactoredData;
}

export function getTutorialSideBarDataRefactored(pages: any) {
  let refactoredData: Sidebar[] = [];
  pages.edges.forEach((page) => {
    const nestedCat = [];
    pages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        nestedCat.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: null,
        nestedCategories: [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function getTutorialHardwareSideBarDataRefactored(actualPage: string, data: any) {
  let refactoredData: Sidebar[] = [];
  let nestedChild = [];
  data.tutorials.edges.forEach((tutorial) => {
    nestedChild.push({ title: tutorial.node.childMdx.frontmatter.title, url: tutorial.node.fields.slug });
  });

  const nestedCat = [{ category: 'Tutorials', nestedChildren: nestedChild }];

  refactoredData.push({
    firstLevelCategory: actualPage,
    nestedCategories: nestedCat,
  });

  return refactoredData;
}

export function getLibrarySideBarDataRefactored(currentName: string, currentSlug: string) {
  let refactoredData: Sidebar[] = [];
  const nestedChildren: CustomLink[] = [];

  if (typeof window !== 'undefined') {
    const storedNodes = JSON.parse(localStorage.getItem('recentLibraries')) || [];
    let currentPageFounded = false;
    storedNodes?.forEach((dependence) => {
      if (dependence.title === currentName) currentPageFounded = true;
      nestedChildren.push({ title: dependence.title, url: process.env.GATSBY_DOCS_URL + 'libraries/' + dependence.slug });
    });

    if (!currentPageFounded) {
      nestedChildren.unshift({ title: currentName, url: process.env.GATSBY_DOCS_URL + 'libraries/' + currentSlug });
    }
  }

  if (nestedChildren.length === 0) return null;

  refactoredData.push({
    firstLevelCategory: 'Recents',
    nestedCategories: [
      {
        category: 'Recents viewed',
        nestedChildren,
      },
    ],
  });

  return refactoredData;
}

export function getApiSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];
  const nestedChildren: CustomLink[] = [];

  data?.forEach((dependence) => {
    nestedChildren.push({ title: dependence, url: process.env.GATSBY_DOCS_URL + 'libraries/' + dependence });
  });

  if (nestedChildren.length === 0) return [];

  refactoredData.push({
    firstLevelCategory: 'Dependencies',
    nestedCategories: [
      {
        nestedChildren,
      },
    ],
  });

  return refactoredData;
}

export function getHardwareSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];

  data?.families.edges.forEach((family) => {
    const categories = data.categories.edges.filter((category) => isInside(category, family));
    const images = imageFor(data?.images, family);

    const nestedCat = categories
      .sort((a, b) => (a.node.relativeDirectory < b.node.relativeDirectory ? -1 : 1))
      .map((category) => {
        const nestedChild = data.products.edges
          .filter((product) => isInside(product, category))
          .sort((a, b) => (a.node.relativeDirectory < b.node.relativeDirectory ? -1 : 1))
          .map((product) => {
            if (product.node.childMdx?.frontmatter?.title) {
              return {
                title: product.node.childMdx.frontmatter.title,
                url: product.node.fields.slug,
              };
            } else return null;
          });
        return { category: category.node.childMdx?.frontmatter.title, nestedChildren: nestedChild };
      });
    if (family.node.childMdx) {
      refactoredData.push({
        firstLevelCategory: family.node?.childMdx?.frontmatter?.title,
        businessUnit: family.node.childMdx.frontmatter.businessUnit,
        anchor: family.node.childMdx.frontmatter.anchor ?? null,
        image: images,
        nestedCategories: nestedCat,
      });
    }
  });

  return refactoredData;
}

export function getCloudSideBarDataRefactored(data: any) {
  let refactoredData: Sidebar[] = [];

  data.pages.edges.forEach((page) => {
    const parts = page.node.relativeDirectory.split('/');

    const nestedChildren: CustomLink[] = [];
    data.pages.edges.forEach((childPage) => {
      const nestedParts = childPage.node.relativeDirectory.split('/');
      if (nestedParts.length > 2) {
        if (
          page.node.relativeDirectory.length !== childPage.node.relativeDirectory.length &&
          childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) !== -1
        ) {
          nestedChildren.push({ title: childPage.node.childMdx.frontmatter.title, url: childPage.node.fields.slug });
        }
      }
    });

    if (parts.length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        image: page.node.childMdx.frontmatter.icon,
        nestedCategories: [
          {
            nestedChildren,
          },
        ],
      });
    }
  });

  return refactoredData;
}

export function getLanguageReferenceSideBarDataRefactored(data: any, language: string) {
  let refactoredData: Sidebar[] = [];
  let subCategoriesList = [];

  if (!data) return refactoredData;

  data[language]?.edges.forEach((page) => {
    if (page.node.name === 'subCategory' && page.node.relativeDirectory.split('/').length === 3) {
      subCategoriesList.push(page.node.childMdx.frontmatter.title);
    }
  });

  data[language]?.edges.forEach((page) => {
    if (!page.node.relativeDirectory) return;
    const parts = page.node.relativeDirectory.split('/');
    const nestedCat = subCategoriesList.map((category) => {
      const nestedChild: CustomLink[] = data[language].edges
        .filter((product) => isInsideSubCategory(product, category, page.node.childMdx.frontmatter.title))
        .map((leaf) => {
          return {
            title: leaf.node.childMdx.frontmatter.title,
            url: language === 'en' ? LANGUAGE_REFERENCE_EN_PAGE + leaf.node.fields.slug : LANGUAGE_REFERENCE_PAGE + language + leaf.node.fields.slug,
            leaf: leaf.node.childMdx.frontmatter.leaf ?? false,
          };
        });
      return { category: nestedChild.length > 0 ? category : null, nestedChildren: nestedChild };
    });

    if (parts.length !== 2) return null;

    //Main Cat
    refactoredData.push({
      firstLevelCategory: page.node.childMdx.frontmatter.title,
      image: null,
      nestedCategories: nestedCat.filter((cat) => cat.category !== null),
    });
  });

  return refactoredData;
}

export function getMicropythonSideBarDataRefactored(data: any, images?: any) {
  let refactoredData: Sidebar[] = [];

  data.micropythonPages.edges.forEach((page) => {
    const nestedCat = [];

    const micropython101Courses = [];
    const micropython101Project = [];
    data.micropythonPages.edges.forEach((childPage) => {
      if (
        page.node.relativeDirectory.length === childPage.node.relativeDirectory.length ||
        childPage.node.relativeDirectory.indexOf(page.node.relativeDirectory) === -1
      ) {
        return null;
      } else {
        if (images) {
          let img = null;
          images.edges.forEach((image, index) => {
            //If there is no image inside the folder, it does not enter and insert the folder in the sidebar
            if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
              img = image.node.childImageSharp;

              nestedCat.push({
                title: childPage.node.childMdx.frontmatter.title,
                description: childPage.node.childMdx.frontmatter.description,
                url: childPage.node.fields.slug,
                author: childPage.node.childMdx.frontmatter.author,
                date: childPage.node.fields.gitLogLatestDate,
                image: img,
              });
              return;
            } else if (index === 0) {
              nestedCat.push({
                title: childPage.node.childMdx.frontmatter.title,
                description: childPage.node.childMdx.frontmatter.description,
                url: childPage.node.fields.slug,
                author: childPage.node.childMdx.frontmatter.author,
                date: childPage.node.fields.gitLogLatestDate,
                image: null,
              });
            }
          });
        } else {
          nestedCat.push({
            title: childPage.node.childMdx.frontmatter.title,
            description: childPage.node.childMdx.frontmatter.description,
            url: childPage.node.fields.slug,
            author: childPage.node.childMdx.frontmatter.author,
            date: childPage.node.fields.gitLogLatestDate,
          });
        }
      }
    });

    // micropythonCourses
    data.micropythonPages.edges.forEach((childPage) => {
      if (childPage.node.relativeDirectory.split('/').some((segment) => /^..\.micropython-course$/.test(segment))) {
        if (childPage.node.relativeDirectory.split('/').includes('course')) {
          if (images) {
            let img = null;
            images.edges.forEach((image) => {
              if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
                img = image.node.childImageSharp;

                micropython101Courses.push({
                  title: childPage.node.childMdx.frontmatter.title,
                  description: childPage.node.childMdx.frontmatter.description,
                  url: childPage.node.fields.slug,
                  author: childPage.node.childMdx.frontmatter.author,
                  date: childPage.node.fields.gitLogLatestDate,
                  image: img,
                });
                return;
              }
            });
          } else {
            micropython101Courses.push({
              title: childPage.node.childMdx.frontmatter.title,
              description: childPage.node.childMdx.frontmatter.description,
              url: childPage.node.fields.slug,
              author: childPage.node.childMdx.frontmatter.author,
              date: childPage.node.fields.gitLogLatestDate,
            });
          }
        } else if (childPage.node.relativeDirectory.split('/').includes('projects')) {
          if (images) {
            let img = null;
            images.edges.forEach((image) => {
              if (image.node.relativeDirectory === childPage.node.relativeDirectory) {
                img = image.node.childImageSharp;
                micropython101Project.push({
                  title: childPage.node.childMdx.frontmatter.title,
                  description: childPage.node.childMdx.frontmatter.description,
                  url: childPage.node.fields.slug,
                  author: childPage.node.childMdx.frontmatter.author,
                  date: childPage.node.fields.gitLogLatestDate,
                  image: img,
                });
                return;
              }
            });
          }
        }
      }
    });

    if (page.node.relativeDirectory.split('/').length === 2) {
      refactoredData.push({
        firstLevelCategory: page.node.childMdx.frontmatter.title,
        firstLevelCategoryDescription: page.node.childMdx.frontmatter?.description || null,
        image: page.node.childMdx.frontmatter?.icon || null,
        nestedCategories:
          page.node.childMdx.frontmatter.title === 'MicroPython 101 Course'
            ? [
                { category: 'Courses', nestedChildren: micropython101Courses },
                { category: 'Projects', nestedChildren: micropython101Project },
              ]
            : [{ category: null, nestedChildren: nestedCat }],
      });
    }
  });

  return refactoredData;
}

export function getCliSideBarDataRefactored(cliData) {
  let refactoredData: Sidebar[] = [];

  function formatCliTitle(title) {
    if (title === 'Faq') return 'FAQ';
    else if (title === 'Versioning') return 'Backward compatibility policy';
    else if (title === 'Contributing') return 'How to Contribute';
    else if (title === 'Index') return 'Home';
    return title.replace(/[-_]/g, ' ');
  }

  function reorderNestedChildren(data) {
    const order = ['Home', 'Installation', 'Upgrading', 'Getting started'];
    const nestedChildren = data[0].nestedCategories[0].nestedChildren;

    const prioritizedItems = nestedChildren.filter((item) => order.includes(item.title));
    const remainingItems = nestedChildren.filter((item) => !order.includes(item.title));

    const orderedPrioritizedItems = order.map((title) => prioritizedItems.find((item) => item.title === title));

    data[0].nestedCategories[0].nestedChildren = [...orderedPrioritizedItems, ...remainingItems];

    return data;
  }

  // Prepare sub category for guides, gRPC reference
  const nestedCategories: Array<SidebarCategory> = [
    {
      nestedChildren: cliData
        .filter((item) => !item.category.split('/').includes('guides') && !item.category.split('/').includes('grpc'))
        .map((item) => ({
          title: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())),
          url: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())) === 'Home' ? CLI_PAGE : CLI_PAGE + item.name.slice(0, -3),
        })),
    },
  ];

  // Push guides, gRPC reference
  cliData.forEach((item) => {
    if (item.category.split('/').includes('guides')) {
      nestedCategories.push({
        category: 'Guides',
        nestedChildren: [
          {
            title: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())),
            url: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())) === 'Home' ? CLI_PAGE : CLI_PAGE + item.name.slice(0, -3),
          },
        ],
      });
    }

    if (item.category.split('/').includes('grpc')) {
      nestedCategories.push({
        category: 'gRPC Reference',
        nestedChildren: [
          {
            title: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())),
            url: formatCliTitle(capitalize(item.name.slice(0, -3).toLowerCase())) === 'Home' ? CLI_PAGE : CLI_PAGE + item.name.slice(0, -3),
          },
        ],
      });
    }
  });

  refactoredData.push({
    firstLevelCategory: 'Arduino CLI',
    nestedCategories: nestedCategories,
  });

  // Order element to have Home, Installation and Getting started at top of sidebar
  const orderedResult = reorderNestedChildren(refactoredData);

  return orderedResult;
}

export function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function isInside(element, container) {
  const index = element.node.relativeDirectory.indexOf(container.node.relativeDirectory);

  return index !== -1;
}

export function isInsideSubCategory(element, container, mainCategory) {
  if (element.node.childMdx.frontmatter.subCategories === container && element.node.childMdx.frontmatter.categories === mainCategory) {
    return true;
  }
  return false;
}

export function imageFor(images, family) {
  if (!images) return null;
  return images.edges.filter((image) => {
    return image.node.relativeDirectory === family.node.relativeDirectory;
  });
}

export function getActualPage(parts): ActualPageProps {
  if (parts?.length >= 1 && parts[1] === CLOUD_PATH) return { title: SIDEBAR_CLOUD, url: CLOUD_PAGE };
  // Language Referenfe workaround
  else if (
    (parts?.length >= 1 && parts[1] === LANGUAGE_REFERENCE_PATH && (parts[2] === 'en' || parts[2] === 'de' || parts[2] === 'pt')) ||
    (parts?.length >= 1 && parts[1] === 'en') ||
    (parts?.length >= 1 && parts[1] === 'de') ||
    (parts?.length >= 1 && parts[1] === 'pt')
  ) {
    return { title: SIDEBAR_LANGUAGE, url: parts[2] === 'en' ? LANGUAGE_REFERENCE_PAGE : LANGUAGE_REFERENCE_PAGE + parts[2] };
  } else if (parts[1] === HARDWARE_PATH) {
    if (
      parts[2] === TUTORIAL_COMMUNICATION ||
      parts[2] === TUTORIAL_GENERIC ||
      parts[2] === TUTORIAL_PROJECT ||
      parts[2] === TUTORIAL_NANO_GENERIC ||
      parts[2] === TUTORIAL_SECURITY
    )
      return { title: SIDEBAR_TUTORIALS, url: TUTORIALS_PAGE };
    else return { title: SIDEBAR_HARDWARE, url: HARDWARE_PAGE + parts[parts.length - 3] };
  } else if (parts[1] === SOFTWARE_PATH) {
    if (parts[2] === SOFTWARE_IDE_PATH) return { title: SIDEBAR_IDE_SOFTWARE, url: SOFTWARE_IDE_PAGE };
    else if (parts[2] === SOFTWARE_PLC_PATH) return { title: SIDEBAR_PLC_SOFTWARE, url: SOFTWARE_PLC_PAGE };
    else return { title: SIDEBAR_SOFTWARE, url: SOFTWARE_PAGE };
  } else if (parts[1] === LEARN_PATH) return { title: SIDEBAR_LEARN, url: LEARN_PAGE };
  else if (parts[1] === MYCROPYTHON_PATH) return { title: SIDEBAR_MYCROPYTHON, url: MICROPYTHON_PAGE };
  else if (parts[1] === EXAMPLES_PATH) return { title: SIDEBAR_EXAMPLES, url: EXAMPLES_PAGE };
  if (parts[1] === RETIRED_PATH) return { title: SIDEBAR_LEGACY_DOCS, url: RETIRED_PAGE };
  else return { title: ALL_DOCS, url: '/' };
}

export function getSearchBarActualPage(parts): ActualPageProps {
  if (parts[1] === CLOUD_PATH) return { title: SIDEBAR_CLOUD, url: CLOUD_PAGE };
  else if (parts[1] === PRODUCT_PATH) return { title: SIDEBAR_HARDWARE, url: HARDWARE_PAGE };
  else if (parts[1] === LANGUAGE_REFERENCE_PATH) return { title: SIDEBAR_LANGUAGE, url: LANGUAGE_REFERENCE_PAGE };
  else if (parts[1] === LIBRARY_GEN_PATH) return { title: SIDEBAR_LIBRARY, url: LIBRARY_PAGE };
  else if (parts[1] === HARDWARE_PATH) {
    if (
      parts[2] === TUTORIAL_COMMUNICATION ||
      parts[2] === TUTORIAL_GENERIC ||
      parts[2] === TUTORIAL_PROJECT ||
      parts[2] === TUTORIAL_NANO_GENERIC ||
      parts[2] === TUTORIAL_SECURITY
    )
      return { title: SIDEBAR_TUTORIALS, url: TUTORIALS_PAGE };
    else return { title: SIDEBAR_TUTORIALS, url: TUTORIALS_PAGE };
  } else if (parts[1] === SOFTWARE_PATH) {
    if (parts[2] === SOFTWARE_IDE_PATH) return { title: SIDEBAR_IDE_SOFTWARE, url: SOFTWARE_IDE_PAGE };
    else if (parts[2] === SOFTWARE_PLC_PATH) return { title: SIDEBAR_PLC_SOFTWARE, url: SOFTWARE_PLC_PAGE };
    else return { title: SIDEBAR_SOFTWARE, url: SOFTWARE_PAGE };
  } else if (parts[1] === LEARN_PATH) return { title: SIDEBAR_LEARN, url: LEARN_PAGE };
  else if (parts[1] === MYCROPYTHON_PATH) return { title: SIDEBAR_MYCROPYTHON, url: MICROPYTHON_PAGE };
  else if (parts[1] === EXAMPLES_PATH) return { title: SIDEBAR_EXAMPLES, url: EXAMPLES_PAGE };
  if (parts[1] === RETIRED_PATH) return { title: SIDEBAR_LEGACY_DOCS, url: RETIRED_PAGE };
  else return { title: ALL_DOCS, url: '/' };
}

export function formatString(parts) {
  if (parts === 'stringObject') return 'String';
  else return parts;
}

export function generateCurlExample(openApiSchema, path, method) {
  const baseUrl = 'https://api2.arduino.cc';
  const endpoint = openApiSchema.paths[path][method];

  if (!endpoint) {
    return;
  }

  let curlCommand = `curl -X ${method.toUpperCase()} \\\n`;

  // Header params
  if (endpoint.parameters) {
    endpoint.parameters.forEach((param) => {
      if (param.in === 'header') {
        // && param.name !== 'X-Organization' //code to exclude 'X-Organization'
        const headerValue = param.example || `${param.name}_example`;
        curlCommand += ` -H "<span class="curl-string">${param.name}: ${headerValue}</span>" \\\n`;
      }
    });
  }

  // ? Accept Header based on method and responses - For now we don't need this
  // let acceptHeaderAdded = false;
  // if (method === 'delete') {
  //   curlCommand += ` -H "<span class="curl-string">Accept: application/vnd.goa.error+json,text/plain</span>" \\\n`;
  //   acceptHeaderAdded = true;
  // } else if (endpoint.responses) {
  //   const responseContent = Object.keys(endpoint.responses)[0];
  //   const acceptHeader = Object.keys(endpoint.responses[responseContent]?.content || {});
  //   if (acceptHeader.length > 0) {
  //     curlCommand += ` -H "<span class="curl-string">Accept: ${acceptHeader.join(',')}</span>" \\\n`;
  //     acceptHeaderAdded = true;
  //   }
  // }
  // Add Accept vnd.goa.error for PUT method (if not added already) - we want to hide from last version
  // if (method === 'put' && !acceptHeaderAdded) {
  //   curlCommand += ` -H "<span class="curl-string">Accept: application/vnd.goa.error+json,text/plain</span>" \\\n`;
  // }

  // Header Content-Type for method with body (POST, PUT)
  if (['post', 'put'].includes(method)) {
    curlCommand += ` -H "<span class="curl-string">Content-Type: application/json,application/x-www-form-urlencoded</span>" \\\n`;
  }

  // query parameters
  let queryParams = '';
  if (endpoint.parameters) {
    endpoint.parameters.forEach((param) => {
      if (param.in === 'query') {
        const paramName = param.name;
        const paramExample = param.example || `${paramName}_example`;
        queryParams += `${paramName}=${paramExample}&`;
      }
    });
  }
  if (queryParams) {
    queryParams = '?' + queryParams.slice(0, -1);
  }

  // URL e payload
  const url = `${baseUrl}${path}${queryParams}`;
  curlCommand += ` "<span class="curl-string">${url}</span>"`;

  // Add specific params
  if (method === 'put' && path === '/iot/v2/devices') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
      "connection_type" : "wifi",
      "serial" : "serial",
      "user_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91",
      "fqbn" : "fqbn",
      "name" : "name",
      "wifi_fw_version" : "wifi_fw_version",
      "type" : "mkrwifi1010"
    }</span>' \n`;
  } else if (method === 'put' && path === '/iot/v2/devices/{id}/certs') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
        "csr" : "-----BEGIN CERTIFICATE-----\n\t\t\tMIIBeDCCAR4CAQAwgY0xCzAJBgNVBAYTAkFVMRMwEQYDVQQIEwpTb21lLVN0YXRl\n\t\t\tMQ8wDQYDVQQHEwZNeUNpdHkxFDASBgNVBAoTC0NvbXBhbnkgTHRkMQswCQYDVQQL\n\t\t\tEwJJVDEUMBIGA1UEAxMLZXhhbXBsZS5jb20xHzAdBgkqhkiG9w0BCQEMEHRlc3RA\n\t\t\tZXhhbXBsZS5jb20wWTATBgcqhkjOPQIBBggqhkjOPQMBBwNCAATf6J9Gk79XGJ2I\n\t\t\t+v6p/r0UmPufUcUwtlx7gx87+DaI8Vpj9R5KN71HsHYw5uq+Lm0cr0CZIdtZU4cP\n\t\t\tupd6jDQToC4wLAYJKoZIhvcNAQkOMR8wHTAbBgNVHREEFDASgRB0ZXN0QGV4YW1w\n\t\t\tbGUuY29tMAoGCCqGSM49BAMCA0gAMEUCIGQqtlGzYdjPwYZYJ41albMBcdrKI7+8\n\t\t\toiNSNWyDxJSGAiEAqQPPxMdr6vaXCCjr5s1J01WLKHzGoPFCR40rqAPs8eQ=\n\t\t\t-----END CERTIFICATE-----\n\t\t\t",
        "ca" : "ca",
        "enabled" : true
      }</span>' \n`;
  } else if (method === 'post' && path === '/iot/v2/devices/{id}/pass') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
    "password" : "password"
  }</span>' \n`;
  } else if (method === 'put' && path === '/iot/v1/lora-devices/') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
  "app" : "app",
  "app_key" : "app_key",
  "serial" : "serial",
  "user_id" : "user_id",
  "eui" : "eui",
  "frequency_plan" : "EU_863_870_TTN",
  "name" : "name",
  "app_eui" : "app_eui",
  "type" : "lora-device"
}</span>' \n`;
  } else if (
    method === 'post' &&
    (path === '/iot/v2/series/batch_query' || path === '/iot/v2/series/batch_query_raw' || path === '/iot/v2/series/batch_query_sampling')
  ) {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
  "resp_version" : 1,
  "requests" : [ {
    "q" : "q",
    "series_limit" : 6,
    "aggregation" : "AVG",
    "from" : "2000-01-23T04:56:07.000+00:00",
    "interval" : 0,
    "to" : "2000-01-23T04:56:07.000+00:00"
  }, {
    "q" : "q",
    "series_limit" : 6,
    "aggregation" : "AVG",
    "from" : "2000-01-23T04:56:07.000+00:00",
    "interval" : 0,
    "to" : "2000-01-23T04:56:07.000+00:00"
  } ]
}</span>' \n`;
  } else if (method === 'post' && path === '/iot/v2/series/batch_query_raw/lastvalue') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
  "requests" : [ {
    "thing_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91",
    "property_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91"
  }, {
    "thing_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91",
    "property_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91"
  } ]
}</span>' \n`;
  } else if (method === 'put' && path === '/iot/v2/things/{id}/clone') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
  "name" : "name",
  "include_tags" : true
}</span>' \n`;
  } else if (method === 'put' && path === '/iot/v2/things') {
    curlCommand += `<br />`;
    curlCommand += ` -d '<span class="curl-string">{
  "device_id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91",
  "timezone" : "America/New_York",
  "assistant" : "ALEXA",
  "webhook_uri" : "webhook_uri",
  "name" : "name",
  "id" : "046b6c7f-0b8a-43b9-b35d-6489e6daee91",
  "webhook_active" : true,
  "properties" : [ {
    "min_value" : 6.027456183070403,
    "update_strategy" : "ON_CHANGE",
    "name" : "name",
    "update_parameter" : 5.962133916683182,
    "permission" : "READ_ONLY",
    "persist" : true,
    "tag" : 1,
    "variable_name" : "variable_name",
    "type" : "ANALOG",
    "max_value" : 0.8008281904610115
  }, {
    "min_value" : 6.027456183070403,
    "update_strategy" : "ON_CHANGE",
    "name" : "name",
    "update_parameter" : 5.962133916683182,
    "permission" : "READ_ONLY",
    "persist" : true,
    "tag" : 1,
    "variable_name" : "variable_name",
    "type" : "ANALOG",
    "max_value" : 0.8008281904610115
  } ],
  "tags" : [ {
    "value" : "value",
    "key" : "key"
  }, {
    "value" : "value",
    "key" : "key"
  } ]
}</span>' \n`;
  }

  // body for POST and PUT
  if (['post', 'put'].includes(method) && endpoint.requestBody) {
    curlCommand += " \\\n -d '";
    const bodySchema = endpoint.requestBody?.content?.['application/json']?.schema;
    if (bodySchema) {
      const bodyExample = generateExampleFromSchema(bodySchema, openApiSchema);
      curlCommand += `${JSON.stringify(bodyExample, null, 2)}`;
    }
    // } else {
    //   curlCommand += `<span class="curl-string">Custom MIME type example not yet supported: application/x-www-form-urlencoded</span>`;
    // }
    curlCommand += "'";
  }

  return `<pre>${curlCommand.replace(/\n/g, '<br>').replace(/\\n/g, '<br>&nbsp;&nbsp;&nbsp;&nbsp;')}</pre>`;
}

// Helper function to generate example payload from schema
function generateExampleFromSchema(schema, openApiSchema) {
  const example = {};
  if (schema.properties) {
    Object.keys(schema.properties).forEach((propName) => {
      const property = schema.properties[propName];
      if (property.example) {
        example[propName] = property.example;
      } else if (property.type === 'string') {
        example[propName] = `${propName}_example`;
      } else if (property.type === 'integer') {
        example[propName] = 0;
      } else if (property.type === 'array') {
        example[propName] = [];
      } else if (property.type === 'object') {
        example[propName] = generateExampleFromSchema(property, openApiSchema);
      } else if (property.$ref) {
        const refSchema = resolveRefSchema(property.$ref, openApiSchema);
        example[propName] = generateExampleFromSchema(refSchema, openApiSchema);
      }
    });
  }
  return example;
}

// Helper function to resolve $ref in schema
function resolveRefSchema(ref, openApiSchema) {
  const refPath = ref.replace(/^#\/components\/schemas\//, '');
  return openApiSchema.components.schemas[refPath];
}

export function generateJavascriptExample(openApiSchema, path, method, title) {
  const endpoint = openApiSchema.paths[path][method];

  if (!endpoint) {
    return '';
  }

  function generateFunctionName(title) {
    let words = title.split(' ').filter(Boolean);
    words[words.length - 1] = 'Api';

    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('');
  }

  const apiClassName = generateFunctionName(title);

  function generatePayloadName(title) {
    let words = title.split(' ').filter(Boolean);
    let firstWord = words.pop().toLowerCase();

    let camelCaseWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('');

    return firstWord + camelCaseWords + 'Payload';
  }

  const payloadParameter = generatePayloadName(title);

  // client Base
  const baseClient = `
<span class='keyword'>var</span> <span class='js-constants'>ArduinoIotClient</span> = require(<span class='string'>'@arduino/arduino-iot-client'</span>);
<span class='keyword'>var</span> defaultClient = <span class='js-constants'>ArduinoIotClient</span>.ApiClient.instance;

<span class='comment'>// Configure OAuth2 access token for authorization: oauth2</span>
<span class='keyword'>var</span> oauth2 = defaultClient.authentications[<span class='string'>'oauth2'</span>];
oauth2.accessToken = <span class='string'>"YOUR ACCESS TOKEN"</span>;

<span class='comment'>// Create an instance of the API class</span>
<span class='keyword'>var</span> api = <span class='keyword'>new</span> <span class='js-constants'>ArduinoIotClient</span>.${apiClassName}(); <br/>
`.trim();

  // path parameters
  const pathParams = endpoint.parameters
    ? endpoint.parameters
        .filter((param) => param.in === 'path')
        .map((param) => {
          const paramName = param.name;
          let exampleValue;

          // params type
          switch (param.type) {
            case 'boolean':
              exampleValue = `<span class='keyword'>true</span>`;
              break;
            case 'integer':
              exampleValue = 0;
              break;
            case 'number':
              exampleValue = 0.0;
              break;
            case 'string':
              exampleValue = `"${paramName}_example"`;
              break;
            default:
              exampleValue = `"${paramName}_example"`;
          }

          return `<span class='keyword'>var</span> ${paramName} = ${param.example || exampleValue}; // {${param.type}} ${
            param.description || ''
          } <br />`;
        })
        .join('\n  ')
    : '';

  // header and query parameters
  const opts = endpoint.parameters
    ? endpoint.parameters
        .filter((param) => param.in === 'header' || param.in === 'query')
        .map((param) => {
          const paramName = param.name;
          let exampleValue;

          switch (param.type) {
            case 'boolean':
              exampleValue = true;
              break;
            case 'integer':
              exampleValue = 0;
              break;
            case 'number':
              exampleValue = 0.0;
              break;
            case 'string':
              exampleValue = `"${paramName}_example"`;
              break;
            case 'array':
              exampleValue = `[]`;
              break;
            case 'object':
              exampleValue = `{}`;
              break;
            default:
              exampleValue = `"${paramName}_example"`;
          }

          return `<span class='string'>'${paramName}'</span>: ${param.example || exampleValue}; // {${param.type}} ${param.description || ''}`;
        })
        .join(',\n  ')
    : '';

  // add params inside api calls
  let methodSpecificCode = '';
  if (method === 'get') {
    methodSpecificCode = `
<span class='keyword'>var</span> opts = {
  ${opts}
};
api.${title.replace(/ /g, '').charAt(0).toLowerCase() + title.replace(/ /g, '').slice(1)}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' ')[2])
            .join(', ')}, `
        : ''
    }opts).then(<span class='keyword'>function</span>(data) {
  <span class='keyword'>console</span>.log(<span class='string'>'API called successfully. Returned data: '</span> + data);
}, <span class='keyword'>function</span>(error) {
  <span class='keyword'>console</span>.error(error);
});
`.trim();
  } else if (method === 'post') {
    const bodyParam = endpoint.requestBody
      ? `<span class='keyword'>var</span> ${payloadParameter} = {}; <span class='comment'>// {${payloadParameter}}\n</span>`
      : '';
    methodSpecificCode = `${bodyParam}
<span class='keyword'>var</span> opts = {
  ${opts}
};
api.${title.replace(/ /g, '').charAt(0).toLowerCase() + title.replace(/ /g, '').slice(1)}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' ')[2])
            .join(', ')}, `
        : ''
    }${payloadParameter}, opts).then(<span class='keyword'>function</span>(data) {
  <span class='keyword'>console</span>.log(<span class='string'>'API called successfully. Returned data: '</span> + data);
}, <span class='keyword'>function</span>(error) {
  <span class='keyword'>console</span>.error(error);
});
`.trim();
  } else if (method === 'put') {
    const bodyParam = endpoint.requestBody
      ? `<span class='keyword'>var</span> ${payloadParameter} = {}; <span class='comment'>// {${payloadParameter}}\n</span>`
      : '';
    methodSpecificCode = `${bodyParam}
<span class='keyword'>var</span> opts = {
  ${opts}
};
api.${title.replace(/ /g, '').charAt(0).toLowerCase() + title.replace(/ /g, '').slice(1)}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' ')[2])
            .join(', ')}, `
        : ''
    }${payloadParameter}, opts).then(<span class='keyword'>function</span>(data) {
  <span class='keyword'>console</span>.log(<span class='string'>'API called successfully. Returned data: '</span> + data);
}, <span class='keyword'>function</span>(error) {
  <span class='keyword'>console</span>.error(error);
});
`.trim();
  } else if (method === 'delete') {
    methodSpecificCode = `
<span class='keyword'>var</span> opts = {
  ${opts}
};
api.${title.replace(/ /g, '').charAt(0).toLowerCase() + title.replace(/ /g, '').slice(1)}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' ')[2])
            .join(', ')}, `
        : ''
    }opts).then(<span class='keyword'>function</span>() {
  <span class='keyword'>console</span>.log(<span class='string'>'API called successfully.'</span>);
}, <span class='keyword'>function</span>(error) {
  <span class='keyword'>console</span>.error(error);
});
`.trim();
  } else {
    return '';
  }

  return `<pre>${
    baseClient +
    pathParams +
    methodSpecificCode
      .replace(/<span class='keyword'>var<\/span>/g, "<span class='keyword'>var</span>")
      .replace(/<span class='keyword'>function<\/span>/g, "<span class='keyword'>function</span>")
      .replace(/<span class='keyword'>console\.log<\/span>/g, "<span class='keyword'>console.log</span>")
      .replace(/<span class='keyword'>console\.error<\/span>/g, "<span class='keyword'>console.error</span>")
      .replace(/<span class='keyword'>then<\/span>/g, "<span class='keyword'>then</span>")
      .replace(/<span class='keyword'>catch<\/span>/g, "<span class='keyword'>catch</span>")
      .replace(/ArduinoIotClient/g, "<span class='constants'>ArduinoIotClient</span>")
      .replace(/<span class='string'>'([^']*)'<\/span>/g, "<span class='string'>'$1'</span>")
      .replace(/\/\/.*$/gm, "<span class='comment'>$&</span>")
      .replace(/\n/g, '<br>&nbsp;&nbsp;')
  }
</pre>`;
}

export function generatePythonExample(openApiSchema, path, method, title) {
  const endpoint = openApiSchema.paths[path][method];

  if (!endpoint) {
    return '';
  }

  function generateFunctionName(title) {
    let words = title.split(' ').filter(Boolean);
    words[words.length - 1] = 'Api';

    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join('');
  }

  const apiClassName = generateFunctionName(title);
  const payloadParameter = title.replace(/ /g, '').charAt(0).toLowerCase() + title.replace(/ /g, '').slice(1);

  const titleParts = title.split(' ');
  const lastWord = titleParts.pop().toLowerCase();
  const apiName = titleParts[0].toLowerCase();
  const version = titleParts[1]?.toLowerCase();

  const apiParameterComment = `# ${lastWord} ${apiName}_${version}`;
  const apiInstanceMethod = title.toLowerCase().split(' ').join('_');

  const importStatements = `
<span class='keyword'>import</span> iot_api_client <span class='keyword'>as</span> iot
<span class='keyword'>from</span> iot_api_client.configuration <span class='keyword'>import</span> <span class='constants'>Configuration</span>
<span class='keyword'>from</span> iot_api_client.api <span class='keyword'>import</span> <span class='constants'>${apiClassName}</span>
<span class='keyword'>from</span> iot_api_client.models <span class='keyword'>import</span> *
<span class='keyword'>from</span> iot_api_client.exceptions <span class='keyword'>import</span> <span class='constants'>ApiException</span> <br /> <br />
`.trim();

  const clientConfig = `
client_config = <span class='constants'>Configuration</span>(host=<span class='string'>"https://api2.arduino.cc"</span>)
client_config.access_token = <span class='string'>"JWT_ACCESS_TOKEN"</span>
client = iot.<span class='constants'>ApiClient</span>(client_config) <br /> <br />
`.trim();

  const apiInstance = `
<span class='comment'># Create an instance of the API class</span>
apiInstance = <span class='constants'>${apiClassName}</span>(client) <br />
`.trim();

  const formatParamName = (name) => name.replace(/[_-](.)/g, (_, char) => char.toUpperCase());

  // path params
  const pathParams = endpoint.parameters
    ? endpoint.parameters
        .filter((param) => param.in === 'path')
        .map((param) => {
          const formattedName = formatParamName(param.name);
          return `${formattedName} = <span class='string'>${param.example || `"${param.name}_example"`}</span>;  <span class='comment'># ${
            param.type
          } object instance | ${param.description || ''}</span> <br/>`;
        })
        .join('\n')
    : '';

  const queryOrHeaderParams = endpoint.parameters
    ? endpoint.parameters
        .filter((param) => param.in === 'query' || param.in === 'header')
        .map((param) => {
          const formattedName = formatParamName(param.name);
          let exampleValue;
          let comment = `# ${param.type} object instance | ${param.description || ''}`;

          switch (param.type) {
            case 'boolean':
              exampleValue = `<span class='keyword'>true</span>`;
              break;
            case 'integer':
              exampleValue = 0;
              break;
            case 'array':
              exampleValue = `[]`;
              break;
            case 'number':
              exampleValue = 0.0;
              break;
            case 'string':
              exampleValue = `"<span class='string'>${param.name}_example</span>"`;
              break;
            default:
              exampleValue = `"${param.name}_example"`;
          }

          return `${formattedName} = ${param.example || exampleValue};  <span class='comment'> ${comment}</span> `;
        })
        .join('\n')
    : '';

  const requestBody = endpoint.requestBody
    ? `
${payloadParameter} =  <span class='comment'># ${payloadParameter} object instance |</span>
`
    : '';

  let methodSpecificCode = '';

  if (method === 'get') {
    methodSpecificCode = `
<span class='keyword'>try</span>:
    <span class='comment'>${apiParameterComment}</span>
    api_response = apiInstance.${apiInstanceMethod}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }${
      queryOrHeaderParams
        ? `${queryOrHeaderParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    })
    <span class='keyword'>print</span>(api_response)
<span class='keyword'>except</span> <span class='constants'>ApiException</span> <span class='keyword'>as</span> e:
    <span class='keyword'>print</span>(<span class='string'>"Exception when calling ${apiClassName}->${payloadParameter}: %s"</span> % e)
`.trim();
  } else if (method === 'post') {
    methodSpecificCode = `
<span class='keyword'>try</span>:
    <span class='comment'>${apiParameterComment}</span>
    api_response = apiInstance.${apiInstanceMethod}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }, ${
      queryOrHeaderParams
        ? `${queryOrHeaderParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }, ${payloadParameter})
    <span class='keyword'>print</span>(api_response)
<span class='keyword'>except</span> <span class='constants'>ApiException</span> <span class='keyword'>as</span> e:
    <span class='keyword'>print</span>(<span class='string'>"Exception when calling ${apiClassName}->${payloadParameter}: %s"</span> % e)
`.trim();
  } else if (method === 'put') {
    methodSpecificCode = `
<span class='keyword'>try</span>:
    <span class='comment'>${apiParameterComment}</span>
    api_response = apiInstance.${apiInstanceMethod}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }${
      queryOrHeaderParams
        ? `${queryOrHeaderParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }${payloadParameter})
    <span class='keyword'>print</span>(api_response)
<span class='keyword'>except</span> <span class='constants'>ApiException</span> <span class='keyword'>as</span> e:
    <span class='keyword'>print</span>(<span class='string'>"Exception when calling ${apiClassName}->${payloadParameter}: %s"</span> % e)
`.trim();
  } else if (method === 'delete') {
    methodSpecificCode = `
<span class='keyword'>try</span>:
    <span class='comment'>${apiParameterComment}</span>
    apiInstance.${apiInstanceMethod}(${
      pathParams
        ? `${pathParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    }, ${
      queryOrHeaderParams
        ? `${queryOrHeaderParams
            .split('\n')
            .map((param) => param.split(' = ')[0])
            .map((name) => `${formatParamName(name)}=${name}`)
            .join(', ')}`
        : ''
    })
<span class='keyword'>except</span> <span class='constants'>ApiException</span> <span class='keyword'>as</span> e:
    <span class='keyword'>print</span>(<span class='string'>"Exception when calling ${apiClassName}->${payloadParameter}: %s"</span> % e)
`.trim();
  } else {
    return '';
  }

  return `<pre>${
    importStatements +
    clientConfig +
    apiInstance +
    pathParams +
    queryOrHeaderParams +
    requestBody +
    `<br /> <br />` +
    methodSpecificCode.replace(/#/g, '#').replace(/\n/g, '<br>&nbsp;&nbsp;')
  }</pre>`;
}
